import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { Box, Button } from '@mui/material';

import { styles } from '@/components/secret/SecretDisplay/secretDisplayStyles.ts';

import type { ActionButtonsProps } from '@/types';

const ActionButtons = ({ isHidden, handleToggleVisibility, handleCopyAll }: ActionButtonsProps) => {
    return (
        <Box sx={styles.actionButtons}>
            <Button
                variant="contained"
                startIcon={isHidden ? <VisibilityIcon /> : <VisibilityOffIcon />}
                onClick={handleToggleVisibility}
                sx={styles.actionButton}
            >
                {isHidden ? 'Show' : 'Hide'}
            </Button>
            <Button variant="outlined" startIcon={<ContentCopyIcon />} onClick={handleCopyAll} sx={styles.actionButton}>
                Copy
            </Button>
        </Box>
    );
};

export default ActionButtons;
